import { CommonModule } from '@angular/common';
import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { UtilsService } from '@zlib/services/utils.services';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzSliderModule } from 'ng-zorro-antd/slider';
import {
    NzUploadChangeParam,
    NzUploadFile,
    NzUploadModule
} from 'ng-zorro-antd/upload';

import {
    base64ToFile,
    ImageCroppedEvent,
    ImageCropperComponent,
    ImageCropperModule,
    ImageTransform
} from 'ngx-image-cropper';
import { Observable, Observer } from 'rxjs';
@Component({
    selector: 'nz-upload-cropper',
    templateUrl: './nz-upload-cropper.component.html',
    styleUrls: ['./nz-upload-cropper.component.scss'],
    imports: [
        CommonModule,
        ImageCropperModule,
        NzModalModule,
        NzUploadModule,
        TranslateModule,
        NzSliderModule,
        NzLayoutModule,
        NzGridModule,
        NzIconModule,
        FormsModule,
    ]
})
export class NzUploadCropperComponent implements OnInit {
    @ViewChild(ImageCropperComponent) imageCropper: ImageCropperComponent;

    @Input() nzCustomRequest: (item: any) => void;

    @Output() nzChange: EventEmitter<NzUploadChangeParam> =
        new EventEmitter<NzUploadChangeParam>();

    @Input() nzBeforeUpload: (
        file: NzUploadFile,
        fileList: NzUploadFile[]
    ) => boolean | Observable<boolean>;
    @Input() ratio: number = 4 / 3;
    @Input() nzAccept = 'image/png,image/jpeg,image/bmp,image/jpg,image/gif';

    @Input() nzShowUploadList: boolean;

    @Input() previewImageUrl: string;
    @Input() maxSizeBytes = 0;

    @Input() minWidth = 0;
    @Input() resizeToWidth = 0;

    croppedImage: any = '';
    fileName: string;
    zoom: 1;
    rotate: 0;
    transform: ImageTransform = {};

    isImageCropVisible: boolean;
    imageFile: any;
    maintainAspectRatio = false;
    _ratio: number;
    nzChangeEvent: any;
    fileSizeLimitString = '';

    constructor(
        private utilsService: UtilsService,
        private translateService: TranslateService
    ) {}

    ngOnInit(): void {
        if (!this.nzCustomRequest) {
            this.nzCustomRequest = (item: any) => {};
            // do nothing here
        }

        this.maxSizeBytes = 5 * 1024 * 1024 || 0;

        if (this.maxSizeBytes > 0) {
            this.fileSizeLimitString = this.utilsService.fileSizeToString(
                this.maxSizeBytes
            );
        }
        this.nzBeforeUpload = this.nzBeforeUploadCustom;
    }

    imageCropped(event: ImageCroppedEvent) {
        this.croppedImage = event.base64;
    }

    public blobToFile = (theBlob: Blob, fileName: string): File => {
        const b: any = theBlob;
        b.lastModifiedDate = new Date();
        b.name = fileName;
        b.filename = fileName;
        return <File>theBlob;
    };

    fileChangeEvent(event: any) {}

    handleCancel() {
        this.isImageCropVisible = false;
        this.maintainAspectRatio = false;
    }
    onZoomChange() {
        this.transform = {
            ...this.transform,
            scale: this.zoom
        };
    }

    handleNzChange(info: { file: NzUploadFile }): void {
        this.nzChangeEvent = info;
        this.fileName = info.file.originFileObj.name;

        this.isImageCropVisible = true;
        this.zoom = 1;
        this.rotate = 0;

        setTimeout(() => {
            this.maintainAspectRatio = true;
            this._ratio = this.ratio;
            this.onZoomChange();
        });

        this.imageFile = info.file.originFileObj;
    }

    returnImage() {
        this.maintainAspectRatio = false;
        this.croppedImage = this.imageCropper.crop();
        this.isImageCropVisible = false;
        const file = base64ToFile(this.croppedImage.base64);

        // this.nzChangeEvent.file.originFileObj = this.blobToFile(file, this.fileName);
        this.nzChangeEvent.file.originFileObj = new File(
            [file],
            this.fileName,
            { type: this.nzChangeEvent.file.type }
        );
        this.nzChangeEvent.file.status = 'uploading';
        this.nzChange.emit(this.nzChangeEvent);
    }

    nzBeforeUploadCustom = (file: NzUploadFile, _fileList: NzUploadFile[]) => {
        const $this = this;
        return new Observable((observer: Observer<boolean>) => {
            if (this.maxSizeBytes !== 0 && file.size > this.maxSizeBytes) {
                const message = this.translateService.instant(
                    'notification.image_size_error',
                    { maxSize: this.fileSizeLimitString }
                );
                this.utilsService.createErrorNotification(message, '');
                observer.complete();
            }

            const reader = new FileReader();
            reader.readAsDataURL(file as any);
            reader.onload = () => {
                const img = new Image();
                img.src = reader.result as string;
                img.onload = () => {
                    // const height = img.naturalHeight;
                    const width = img.naturalWidth;
                    // console.log('Width and Height', width, height);
                    if ($this.minWidth !== 0 && width < $this.minWidth) {
                        const message = $this.translateService.instant(
                            'notification.image_min_with_error',
                            { minWidth: $this.minWidth }
                        );
                        this.utilsService.createErrorNotification(message, '');
                        observer.complete();
                    } else {
                        observer.next(true);
                        observer.complete();
                    }
                };
            };
        });
    };
}
